<script setup>
defineProps({ modelValue: String, items: { type: Array, default: () => [] } });
defineEmits(["update:modelValue"]);
</script>
<template>
  <div class="ui-tabs" role="tablist">
    <button
      v-for="item in items"
      :key="item.value"
      type="button"
      :class="['ui-tab', modelValue === item.value && 'ui-tab-active']"
      @click="$emit('update:modelValue', item.value)"
    >
      <component :is="item.icon" v-if="item.icon" class="size-4" />
      <span>{{ item.label }}</span>
      <span v-if="item.badge" class="rounded bg-slate-100 px-1.5 py-0.5 text-[10px]">{{ item.badge }}</span>
    </button>
  </div>
</template>

